import { PanelAction, PanelState, PanelType, PriceLevelFilterState, SelectableInfo, TicketTypeItem } from "@/domain/ticket-selection";

export class PanelStateService {
    private state: PanelState = {
        activePanel: null,
        isPanelOpen: false,
        actions: {
            selectFilter: null,
            selectTicketType: null,
            removeSelection: null,
            submitSelection: false,
        }
    };

    public get actions(): PanelAction {
        return this.state.actions;
    }

    public get activePanel(): PanelType | null {
        return this.state.activePanel;
    }

    public get isPanelOpen(): boolean {
        return this.state.isPanelOpen;
    }

    public triggerAddToCart() {
        this.setAction({ submitSelection: true });
    }

    public closePanel() {
        this.state.isPanelOpen = false;
        this.state.activePanel = null;
    }

    public activatePromotionPanel() {
        this.setActivePanelTo(PanelType.PROMO);
    }

    public activateInfoPanel() {
        this.setActivePanelTo(PanelType.INFO);
    }

    public isPromotionPanelActive(): boolean {
        return this.state.activePanel === PanelType.PROMO;
    }

    public activateFilterPanel() {
        this.setActivePanelTo(PanelType.FILTER);
    }

    public activateSelectionPanel() {
        this.setActivePanelTo(PanelType.SELECTION);
    }

    public removeActivePanel() {
        this.setActivePanelTo(null);
    }

    public updateFilter(filter: PriceLevelFilterState) {
        if (this.actions.selectFilter && filter.id === this.actions.selectFilter.id) {
            this.setAction({ selectFilter: null }, true);
        } else {
            this.setAction({ selectFilter: filter }, true);
        }
    }

    public updateSelectedTicketType(selectable: SelectableInfo, ticketType: TicketTypeItem) {
        this.setAction({
            selectTicketType: {selectionItem: selectable, active: ticketType}
        });
    }

    public removeSelection(ticket: SelectableInfo) {
        this.setAction({removeSelection: ticket});
    }

    private setAction(action: Partial<PanelAction>, shouldClosePanel = false): void {
        if (shouldClosePanel) {
            this.setActivePanelTo(null);
        }

        this.state.actions = {
            ...this.state.actions,
            ...action
        };
    }

    private setActivePanelTo(panel: PanelType | null): void {
        this.state.activePanel = panel;

        if (panel) {
            this.state.isPanelOpen = true;
        }
    }
}